import { Component, ReactNode } from "react";

import { SwivlException } from "../Helpers/Datadog/Datadog";
import { AlertsModel } from "../Models/Notifications/Alerts.Model";
import GlobalSearchModalModel from "./GlobalSearchModal.Model";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

// Error boundaries must be class components — no hook equivalent exists.
export class GlobalSearchErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    SwivlException.capture(error, "Global search crashed");
    AlertsModel.errorToast("Search hit an error. Try again or refresh the page.");
    // Closes the palette so the next open is a fresh mount, not stuck.
    GlobalSearchModalModel.close();
  }

  render(): ReactNode {
    // The toast carries the message now — nothing to render here.
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
